/**
 * 动画库
 * @module Animate
 */
;(function (ui,$) {
    "use strict";
  /**
   * 常用动画切换器,只能运行已经配置好的动画,更多效果需要引入animate.css 外部样动画库 <br>
   * <a href="../../ui_method/bui.toggle.html" target="_blank">demo</a> <br>
   * 
   * {{#crossLink "bui.toggle/option"}}{{/crossLink}}: 获取设置参数 <br>
   * {{#crossLink "bui.toggle/widget"}}{{/crossLink}}: 获取依赖控件 <br>
   * {{#crossLink "bui.toggle/show"}}{{/crossLink}}: 显示 <br>
   * {{#crossLink "bui.toggle/hide"}}{{/crossLink}}: 隐藏 <br>
   * {{#crossLink "bui.toggle/remove"}}{{/crossLink}}: 移除 <br>
   * @namespace  bui
   * @class  toggle
   * @param {string} id [要操控的元素的选择器]
   * @param {string} effect [内置的效果, fadeIn | fadeInLeft | fadeInRight | fadeInDown | fadeInUp | fadeInLeftBig | fadeInRightBig | fadeInUpBig | fadeInDownBig | zoomIn | bounceIn | rotateIn | flipInX | flipInY]
   * @constructor 
   * @example
   * 
    方法1: 
   *
            //初始化page对象
        var uiToggle = bui.toggle("#page");

            //显示动画
            uiToggle.show();
            
            //隐藏动画
            uiToggle.hide();
        
    方法2:
    *
        var uiToggle = bui.toggle({ id:"#page" ,effect:"fadeInLeft"});
            uiToggle.show();
            uiToggle.hide();
        
    方法3: 自定义动画库里面没有的动画
    *
        var uiToggle = bui.toggle("#page");
            uiToggle.show("fadeInLeft");
            uiToggle.hide("fadeOutLeft");
   * 
   */
    ui.toggle = function (option) {
        
        //默认配置
        var config = {
            id: "",
            effect: "fadeIn"
        }

        if( typeof option === "string" ){
            var opt = option || "";

            option = {};
            option.id = opt;
        }

        //方法
        var module = {
            show: show,      //显示效果
            hide: hide,      //隐藏效果
            remove: remove,
            widget: widget,
            option: options,
            config: param,
            init: init
        };
        //用于option方法的设置参数
        var param = module.config = $.extend(true,{}, config, option );
        
        //内置的常用动画
        var animated = {
            show: ["fadeIn","fadeInLeft","fadeInRight","fadeInDown","fadeInUp","fadeInLeftBig","fadeInRightBig","fadeInUpBig","fadeInDownBig","zoomIn","bounceIn","rotateIn","flipInX","flipInY"],
            hide: ["fadeOut","fadeOutLeft","fadeOutRight","fadeOutUp","fadeOutDown","fadeOutLeftBig","fadeOutRightBig","fadeOutUpBig","fadeOutDownBig","zoomOut","bounceOut","rotateOut","flipOutX","flipOutY"]
        };

        var id,
            $id,
            hideClass,
            showClass,
            ticking = false, //动画跟踪
            myClass;

        //初始化
        init(param);

        //初始化动画对象
        function init (option) {
            option = option || param;
            
            if( option.id ){
                $id = ui.obj(option.id);
            }else{
                ui.hint("toggle id不能为空");
                return;
            }

            //option获取新参数使用
            param = module.config = option;

            myClass = $id.attr('class') || "";

            var effect = option.effect ;
            var showIndex = effect && ( ui.inArray(effect,animated["show"]) || ui.inArray(effect,animated["hide"]) );

            //检测在不在已经有的动画里面
            if( showIndex < 0 ){
                showClass = animated["show"][0];
                hideClass = animated["hide"][0];
            }else{
                showClass = animated["show"][showIndex];
                hideClass = animated["hide"][showIndex];

                return;
            }

            return this;
        }
        
        /**
         *  显示动画
         *  @method show
         *  @param {string} [effect] 指定动画效果
         *  @param {function} [callback] 回调
         *  @chainable
         *  @example 
         *  
            var uiToggle = bui.toggle("#page");
                uiToggle.show();
         */
        function show (effect,callback) {

            if( typeof effect === "function"){
                callback = effect;
                effect = showClass || ""
            }else{
                effect = effect || showClass || "";
            }

            param.showClass = effect;

            $id.attr( "class",myClass ).removeClass(hideClass)
                    .addClass( "animated " + effect );
            // $id.one('webkitAnimationStart',function(){
            //     $id.css("display","block");
            //     //执行回调
            // });

            $id.one('webkitAnimationEnd',function(){
                //执行回调
                callback && callback.call(this,module);
            });

            return this;
        }

        
        /**
         *  隐藏动画
         *  @method hide
         *  @param {string} [effect] 指定动画效果
         *  @param {function} [callback] 回调
         *  @chainable
         *  @example 
         *  
            var uiToggle = bui.toggle("#page");
                uiToggle.hide();
         */
        function hide (effect,callback) {

            if( typeof effect === "function"){
                callback = effect;
                effect = hideClass || "";
            }else{
                effect = effect || hideClass || "";
            }

            $id.attr( "class",myClass ).removeClass(showClass)
                    .addClass( "animated " + effect);

            param.hideClass = effect;

            $id.one('webkitAnimationEnd',function(){
                
                $id.css("display","none");
                //执行回调
                callback && callback.call(this,module);
            });

            return this;
        }

        /**
         *  删除动画元素
         *  @method remove
         *  @chainable
         *  @example 
         *  
            var uiToggle = bui.toggle("#page");
                uiToggle.remove();
         */
        function remove () {
            $id.remove();

            return this;
        }

        /**
         * 获取依赖的控件
         *  @method widget
         *  @param {string} [name] [ 依赖控件名 ]
         *  @example 
            
            //获取依赖控件
            var uiToggleWidget = uiToggle.widget();
            
                
         */
        function widget(name) {
            var control = {};
            return ui.widget.call(control,name);
        };
        /**
         * 获取设置参数
         *  @method option
         *  @param { string | object } [key] [ 不传则获取所有参数, 类型为string,没有第2个参数则获取某个参数 ]
         *  @param { string | number | boolean | function } [value] [ 设置参数的时候要传,设置多个参数不用传,获取参数的时候也不用传 ]
         *  @chainable
         *  @example 
            
            
            //获取所有参数
             //获取所有参数
            var option = uiToggle.option();

            //获取某个参数
            var id = uiToggle.option( "id" );

            //修改一个参数
            uiToggle.option( "time",10 );

            //修改多个参数
            uiToggle.option( {"time":10} );
                
         */
        function options (key,value) {

           return ui.option.call(module,key,value);
        }

        return module;
    }

    return ui;

})( bui || {}, libs );
